var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative w-full text-left"
  }, [_c('div', {
    staticClass: "relative"
  }, [_c('TextInput', {
    class: ['w-full pr-8', _vm.disabled ? 'cursor-not-allowed' : 'cursor-pointer'],
    attrs: {
      "type": "text",
      "readonly": "",
      "disabled": _vm.disabled,
      "value": _vm.inputValue,
      "placeholder": _vm.defaultText,
      "variant": _vm.isError ? 'error' : 'default'
    },
    on: {
      "click": function ($event) {
        !_vm.disabled && _vm.toggleDropdown();
      }
    }
  }), _c('ChevronDownFilled', {
    attrs: {
      "className": ("absolute right-3 top-1/2 transform -translate-y-1/2 h-3 w-3 pointer-events-none " + (_vm.disabled ? 'text-gray-400' : 'text-gray-500'))
    }
  })], 1), _vm.isOpen && !_vm.disabled ? _c('div', {
    staticClass: "absolute right-0 z-10 w-full mt-1 bg-white border rounded-md shadow-sm ring-1 ring-black ring-opacity-5"
  }, [_c('div', {
    staticClass: "p-1"
  }, _vm._l(_vm.statusOptions, function (option) {
    return _c('label', {
      key: option.value,
      staticClass: "flex items-center p-2 m-0 cursor-pointer hover:bg-gray-100",
      on: {
        "click": function ($event) {
          return _vm.selectOption(option);
        }
      }
    }, [_c('input', {
      staticClass: "w-4 h-4 text-blue-600 form-radio",
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": option.value,
        "checked": _vm.selectedContentStatus === option.value
      },
      on: {
        "change": function ($event) {
          return _vm.handleRadioChange(option);
        }
      }
    }), _c('span', {
      staticClass: "ml-2 text-gray-700"
    }, [_vm._v(_vm._s(option.text))])]);
  }), 0)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }